type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string
}

const Image = ({ src, ...props }: ImageProps) => <img src={src} {...props} />

export default Image
